module.exports = __webpack_public_path__ + "img/gifts-share-preview.f3ac8bd.jpg";